export default {
  root: {},
  contained: { marginLeft: 4 },
};
